import React__default from 'react';
import { u as useStrings } from './className-ac5eca03.js';
import { S as Screen } from './DocumentScreenSkeleton-f97124ce.js';

function usePageTitle(...title) {
    const { app: strings } = useStrings();
    React__default.useEffect(() => {
        const previousTitle = document.title;
        const parts = [strings.name]; // App name.
        for (const part of title) {
            if (part !== undefined) {
                parts.push(part);
            }
        }
        document.title = parts.reverse().join(' | ');
        return () => {
            document.title = previousTitle;
        };
    }, [title, strings.name]);
}

var faChevronRight = {};

var hasRequiredFaChevronRight;

function requireFaChevronRight () {
	if (hasRequiredFaChevronRight) return faChevronRight;
	hasRequiredFaChevronRight = 1;
	(function (exports) {
		Object.defineProperty(exports, '__esModule', { value: true });
		var prefix = 'fas';
		var iconName = 'chevron-right';
		var width = 320;
		var height = 512;
		var ligatures = [];
		var unicode = 'f054';
		var svgPathData = 'M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z';

		exports.definition = {
		  prefix: prefix,
		  iconName: iconName,
		  icon: [
		    width,
		    height,
		    ligatures,
		    unicode,
		    svgPathData
		  ]};

		exports.faChevronRight = exports.definition;
		exports.prefix = prefix;
		exports.iconName = iconName;
		exports.width = width;
		exports.height = height;
		exports.ligatures = ligatures;
		exports.unicode = unicode;
		exports.svgPathData = svgPathData;
} (faChevronRight));
	return faChevronRight;
}

var faChevronRightExports = requireFaChevronRight();

const NotFoundScreen = () => {
    const { errors: strings } = useStrings();
    return React__default.createElement(Screen, { className: "NotFoundScreen", errorText: strings.pageNotFound });
};

export { NotFoundScreen as N, faChevronRightExports as f, usePageTitle as u };
